import * as Stimulus from "@hotwired/stimulus"

export class GoogleAddressAutoCompleteController extends Stimulus.Controller {
  static targets = [
    "input", "street", "city", "state", "zip", "country"
  ]

  connect() {
    if (!window.google || !google.maps || !google.maps.places) {
      console.error("Google Maps JavaScript API with Places library not loaded.")
      return
    }

    this.autocomplete = new google.maps.places.Autocomplete(this.inputTarget, {
      types: ["address"],
      componentRestrictions: { country: "us" },
      fields: ["address_components", "formatted_address"],
    })

    this.autocomplete.addListener("place_changed", () => {
      this.fillInAddress()
    })
  }

  fillInAddress() {
    const place = this.autocomplete.getPlace()
    if (!place.address_components) return

    const components = {
      street_number: "",
      route: "",
      locality: "",
      administrative_area_level_1: "",
      postal_code: "",
      country: ""
    }

    place.address_components.forEach(component => {
        const type = component.types[0]

        if (type === "administrative_area_level_1") {
            components[type] = component.short_name.toUpperCase() // two-letter state code
        } else if (components[type] !== undefined) {
            components[type] = component.long_name
        }
    })

    const street = `${components.street_number} ${components.route}`.trim()

    if (this.hasStreetTarget) this.streetTarget.value = street
    if (this.hasCityTarget) this.cityTarget.value = components.locality
    if (this.hasStateTarget) this.stateTarget.value = components.administrative_area_level_1
    if (this.hasZipTarget) this.zipTarget.value = components.postal_code
    if (this.hasCountryTarget) this.countryTarget.value = components.country
  }
}

